// extracted by css-extract-rspack-plugin
export default {"emptyModalContent":"emptyModalContent-yaoW9l"};